import * as prismic from '@prismicio/client'
import * as prismicNext from '@prismicio/next'
import sm from './sm.json'

export const repositoryName = prismic.getRepositoryName(sm.apiEndpoint)

const routes = [
  {
    type: 'homepage',
    path: '/',
  },
  {
    type: 'page',
    path: '/:uid',
  },
]

export function linkResolver(doc) {
    switch (doc.type) {
        case 'index':
            return '/'
        case 'page':
            return `/${doc.uid}`
        default:
            return null
    }
}

export const createClient = (config = {}) => {
  const client = prismic.createClient(sm.apiEndpoint, {
    ...config,
  })

  prismicNext.enableAutoPreviews({
    client,
    previewData: config.previewData,
    req: config.req,
  })

  return client
}